export default "__VITE_ASSET__DIkfOWfm__"